import { getPreviousDate } from "../components/utils/dateFormate";
import apiService from "./api";


const articleService = async (domainName,limit,page,  dynamicParams = {},token) => {    
    const queryParams = new URLSearchParams({
        domain: domainName,
        limit:limit,
        pageNo: page,
        ...dynamicParams,
    });
    const url =`/api/v1/admin/get-articles-list?${queryParams.toString()}`;
    try {
        const response = await apiService.get(url,{},token)
        return response
     } catch (error) {
         throw error;
     }
}

export default articleService